import clsx from 'clsx';

import { useTheme } from '@/entities/playdeck/models/playdeck.store';

import s from './LoadingOverlay.module.scss';

interface Props {
  className?: string;
  pdOpen: boolean;
  progress: number;
}

const PROGRESS_END = 100;

export const LoadingOverlay = ({ className, pdOpen, progress }: Props) => {
  const theme = useTheme();

  return (
    <div className={clsx(s.overlay, s[theme], !pdOpen && s.disappearance, className)}>
      <div
        className={clsx(
          s.background,
          s[theme],
          progress !== PROGRESS_END ? s['loading-background'] : s['loaded-background']
        )}
      />
    </div>
  );
};
